import { setDefaultValues, setToTopDimIds } from '../dimensionUtils'
import { isAddable } from './index.js'

export function createDefaultPivotConfig(dimensions) {
  let chart = 'bar-chart'
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas

  let pivotConfig
  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      let type = metas[key].type
      let role = 'filters'
      if (type === 'time') {
        role = 'filters'
      }
      return {
        id: key,
        role: role,
      }
    }),
  }

  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  // let rowsDim = pivotConfig.dimensions.find(d => d.role === 'rows')
  // if (metas[rowsDim.id].type === 'location' && rowsDim.values.length === 1) {
  //   let filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  //   // repensar seguro...
  //   let xCandidate = filterDims.find(d => metas[d.id].type !== 'time') || filterDims[0]
  //   xCandidate.role = 'rows'
  //   rowsDim.role = 'filters'
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  // }

  //RELLENAMOS ROWS Y COLS
  //Seleccionamos la primera extraDim con mas de un valor
  let extraDims = Object.values(dimensions.dimensionMetas).filter(
    d => d.type !== 'time' && d.type !== 'location'
  )
  // let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let filtersExtraDims = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
  )
  //let count = 0
  // while (
  //   count < filtersExtraDims.length &&
  //   rowsDims.length === 1 &&
  //   rowsDims[0].values.length === 1
  // ) {
  //   // if (colsDims.length === 1 && colsDims[0].values.length === 1) {
  //   rowsDims[0].role = 'filters'
  //   toRows = filtersExtraDims.slice(0, 1) // [filtersExtraDims[0]]
  //   toRows.forEach(d => (d.role = 'rows'))
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  //   // }
  //   filtersExtraDims = pivotConfig.dimensions.filter(
  //     d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
  //   )
  //   rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  //   count++
  // }

  let locDim = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && metas[d.id].type === 'location'
  )

  // let timeDim = pivotConfig.dimensions.filter(
  //   d => d.role === 'filters' && metas[d.id].type === 'time'
  // )

  let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let colsDims = pivotConfig.dimensions.filter(d => d.role === 'columns')

  let toRows
  let toCols
  let locDimUsed = false

  if (rowsDims.length === 0 && filtersExtraDims.length > 0) {
    toRows = filtersExtraDims.slice(0, 1)
    toRows.forEach(d => (d.role = 'rows'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  } else if (rowsDims.length === 0 && filtersExtraDims.length === 0 && locDim.length !== 0) {
    toRows = locDim.slice(0, 1)
    locDimUsed = true
    toRows.forEach(d => (d.role = 'rows'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }
  filtersExtraDims = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && extraDims.find(ed => ed.id === d.id)
  )
  if (colsDims.length === 0 && filtersExtraDims.length > 0) {
    toCols = filtersExtraDims.slice(0, 1)
    toCols.forEach(d => (d.role = 'columns'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  } else if (
    colsDims.length === 0 &&
    filtersExtraDims.length === 0 &&
    !locDimUsed &&
    locDim.length !== 0
  ) {
    toCols = locDim.slice(0, 1)
    toCols.forEach(d => (d.role = 'columns'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }

  setToTopDimIds(pivotConfig, metas)

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  return pivotConfig
}

export function getAvailability(dimensions, dataCard) {
  let unit = dataCard.data[0].unit
  let available = isAddable(unit)
  let metas = Object.values(dimensions.dimensionMetas)
  let hasExtraDims = metas.filter(d => d.type !== 'time' && d.type !== 'location').length > 0
  return { enabled: hasExtraDims && available, enableable: hasExtraDims && available }
  //return { enabled: true, enableable: true }
}

export default {
  getAvailability,
  createDefaultPivotConfig,
  maxChartDims: 2,
  maxRowDims: 1,
  sdvComponent: 'Treemap',
  forceSngleTypes: true,
}
